/**
 * Bloques grises animados mientras el repositorio lee los archivos de Drive.
 */
import React from 'react';
import { studio } from '../admin/studioUi';

const SHIMMER_CSS = `
@keyframes cmRepoShimmer { 0% { opacity: 0.55; } 50% { opacity: 1; } 100% { opacity: 0.55; } }
.cm-repo-shimmer { animation: cmRepoShimmer 1.3s ease-in-out infinite; }
`;

const block = { borderRadius: 12, backgroundColor: '#eceaf1' };

export default function LoadingBlock({ rows = 3, label = 'Leyendo los archivos de Drive…' }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} aria-busy="true" aria-label="Cargando">
            <style>{SHIMMER_CSS}</style>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
                {Array.from({ length: 4 }).map((_, i) => <div key={i} className="cm-repo-shimmer" style={{ ...block, height: 86 }} />)}
            </div>
            {Array.from({ length: Math.max(0, rows - 1) }).map((_, i) => (
                <div key={i} className="cm-repo-shimmer" style={{ ...block, height: 220 }} />
            ))}
            <p style={{ ...studio.hint, textAlign: 'center' }}>{label}</p>
        </div>
    );
}
